<template>
  <div class="time-line-content">
    <div v-if="isFixed" style="height: 56px;width: 100%;" class="fix-fill"></div>
    <div class="select-zone-position">
      <div class="shadow-cover"></div>
      <div class="select-zone" :class="isFixed ? 'fixed' : ''">
        <img @click="selectCountry" data-country-name class="global" :src="global" alt />
        <div @click="selectCountry" ref="flagZone" :data-countryName="countryName" v-for="(url, countryName) in flagPic"
          :key="countryName" class="flag-zone">
          <img class="flag-pic" :src="url" alt />
          <p class="country-name">{{ countryName }}</p>
        </div>
      </div>
    </div>
    <div v-if="isLoading" class="loading-list">加载中...</div>
    <div :check="reload" :style="{opacity: reload }" class="time-line-zone"> 
      <div class="head">
        <div class="year">2020</div>
        <div class="sort">
          <div @click="upToDownSort" :style="{ backgroundColor: sortType == 0 ? '#ff604e' : '' }" class="up-to-down">
            <span>正序</span>
          </div>
          <div @click="downToUpSort" :style="{ backgroundColor: sortType == 1 ? '#ff604e' : '' }" class="down-to-up">
            <span>倒序</span>
          </div>
        </div>
      </div>
      <timeLine :dataSource="eventData" @showDialog="showDetails"></timeLine>
      <timeLineDialog :dialogDetails="dialogDetails" v-model="showDialog"></timeLineDialog>
    </div>
    <!-- <img v-show="!reload" class="loading" :src="loading" alt="" /> -->
  </div>
</template>

<script>
  const globalGif = require("@/assets/images/flagPic/地球.gif");
  const globalPng = require("@/assets/images/地球.png");
  import {
    getMainCountryEvent
  } from "@/api/countryEvent";
  import timeLine from "@/components/timeLine/index.vue";
  import timeLineDialog from "@/components/timeLineDialog/index.vue"
  import {
    savePoint
  } from "@/utils/savePoint.js"
  export default {
    props: {
      isFixed: {
        type: Boolean,
        default: false
      },
      closeMask: Function
    },
    components: {
      timeLine,
      timeLineDialog
    },
    data() {
      return {
        timer: null,
        isLoading: false,
        reload: false,
        showDialog:false,
        sortType: 1,
        selectCountryName: "",
        eventData: null,
        loading: require("@/assets/images/loading.gif"),
        global: globalGif,
        globalPng: globalPng,
        flagPic: {
          美国: require("@/assets/images/flagPic/美国.png"),
          英国: require("@/assets/images/flagPic/英国.png"),
          意大利: require("@/assets/images/flagPic/意大利.png"),
          
          西班牙: require("@/assets/images/flagPic/西班牙.png"),
          俄罗斯: require("@/assets/images/flagPic/俄罗斯.png"),
          法国: require("@/assets/images/flagPic/法国.png"),
          德国: require("@/assets/images/flagPic/德国.png"),
          韩国: require("@/assets/images/flagPic/韩国.png"),
          日本: require("@/assets/images/flagPic/日本.png"),
          加拿大: require("@/assets/images/flagPic/加拿大.png"),
          澳大利亚: require("@/assets/images/flagPic/澳大利亚.png"),
          伊朗: require("@/assets/images/flagPic/伊朗.png"),
          
          
          
         
       
          
          伊拉克: require("@/assets/images/flagPic/伊拉克.png")
        },
        dialogDetails: {}
      };
    },
    methods: {
      showDetails(value) {
        console.log("value",value)
        this.showDialog = true
        this.dialogDetails = value
      },
      async getEventData() {
        this.reload = 0;
        let params = {
          country: this.selectCountryName,
          sort: this.sortType
        };
        try {
          this.isLoading = true;
          let res = await getMainCountryEvent(params);
          this.isLoading = false;
          if (res && res.code == 200 && res.data) {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
              this.reload = 1;
              this.eventData = res.data;
              clearTimeout(this.timer);
            }, 50);
            this.$emit("emitClose");
          }
        } catch (e) {
          console.log(e);
          this.$emit("emitClose");
        }
      },
      selectCountry() {
        let target = event.currentTarget;
        this.$refs["flagZone"].forEach(item => {
          if (item.dataset.countryname) {
            item.className = "flag-zone";
          }
        });
        if (!target.dataset.countryname) {
          this.global = globalGif;
        } else {
          this.global = globalPng;
          target.className = "flag-zone flag-pic-selected";
        }
        if (target.dataset.countryname != this.selectCountryName) {
          this.selectCountryName = target.dataset.countryname;
          savePoint({
            deviceid: window.localStorage.getItem("nfplus_deviceid"),
            dataType: "1000099",
            actionTime: Date.parse(new Date()),
            url: window.location.href,
            optionName: this.selectCountryName ? this.selectCountryName : "全球",
            origin: "5",
            action: "19"
          });
          this.getEventData();
        } else {
          return;
        }
      },
      upToDownSort() {
        this.sortType = 0;
        savePoint({
          deviceid: window.localStorage.getItem("nfplus_deviceid"),
          dataType: "1000099",
          actionTime: Date.parse(new Date()),
          url: window.location.href,
          origin: "5",
          action: "13"
        });
        this.getEventData();
      },
      downToUpSort() {
        this.sortType = 1;
        savePoint({
          deviceid: window.localStorage.getItem("nfplus_deviceid"),
          dataType: "1000099",
          actionTime: Date.parse(new Date()),
          url: window.location.href,
          origin: "5",
          action: "12"
        });
        this.getEventData();
      },
      
    },
    mounted() {
      // setTimeout(()=>{
      //   this.getEventData();
      // },5000)
      this.getEventData();
      
    }
  };
</script>

<style lang="less" scoped="scoped">
  .time-line-content {
    background: #f9f9f8;
    position: relative;

    .loading-list {
      text-align: center;
      margin-top: 10px;
      color:grey;
      font-size: 12px;
    }

    .fixed {
      position: fixed !important;
      top: 75px;
      left: 0;
      z-index: 50;
    }

    .select-zone-position {
      width: 100%;
      overflow: hidden;
      height: 56px;
      position: relative;

      .shadow-cover {
        width: 50px;
        height: 56px;
        position: absolute;
        right: 0;
        top: 0;
        pointer-events: none;
        z-index: 5;
        background-image: linear-gradient(90deg, rgba(242, 242, 242, 0) 0%, rgba(172, 172, 172, 1) 100%);
      }

      .select-zone {
        background: #f1f1f1;
        display: flex;
        flex-flow: row nowrap;
        overflow: auto;
        height: 56px;
        width: 100%;
        position: relative;
        box-sizing: content-box;
        padding-bottom: 10px;

        .global {
          display: block;
          height: 30px;
          margin: 13px 16px 0 16px;
        }

        .flag-zone {
          display: flex;
          flex-flow: column nowrap;
          align-items: center;
          justify-content: center;
          padding-right: 18px;
          line-height: 56px;

          .flag-pic {
            display: block;
            width: 46px;
            height: 30px;
            margin-bottom: 3px;
            border-radius: 3px;
            border: 1px solid #fff;
          }

          .country-name {
            font-family: MicrosoftYaHei;
            font-size: 9px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 12px;
            letter-spacing: 1px;
            color: #616161;
            white-space: nowrap;
          }
        }

        .flag-pic-selected {
          .flag-pic {
            border: 1px solid #ff604e;
          }

          .country-name {
            color: #ff604e;
          }
        }
      }
    }

    .loading {
      display: block;
      z-index: 60;
      position: absolute;
      top: 300px;
      left: 50%;
      transform: translate(-50%, 0);
    }

    .time-line-zone {
      opacity: 0;
      transition: all 0.2s;

      .head {
        height: 30px;
        position: relative;

        .year {
          width: 41px;
          border-radius: 8px;
          border: solid 1px #e1e1e1;
          font-family: MicrosoftYaHei;
          font-size: 12px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 16px;
          letter-spacing: 0px;
          color: #c2c2c2;
          text-align: center;
          position: absolute;
          top: 13px;
          left: 61px;
        }

        .sort {
          width: 100px;
          height: 20px;
          display: flex;
          flex-flow: row nowrap;
          background: #c3c3c3;
          border-radius: 3px;
          position: absolute;
          top: 13px;
          right: 23px;

          .up-to-down {
            border-radius: 3px;
            width: 50px;
            transition: all 0.5s;

            span {
              display: flex;
              height: 100%;
              padding-left: 12px;
              background: url("../../assets/images/正序.png") no-repeat 4px 5px;
              background-size: 12px;
              font-size: 10px;
              color: #f9f9f8;
              text-align: center;
              line-height: 20px;
              height: 20px;
              justify-content: center;
              align-items: center;
              line-height: normal;
            }
          }

          .down-to-up {
            border-radius: 3px;
            width: 50px;
            transition: all 0.5s;

            span {
              display: flex;
              height: 100%;
              padding-left: 12px;
              background: url("../../assets/images/倒序.png") no-repeat 4px 5px;
              background-size: 12px;
              font-size: 10px;
              color: #f9f9f8;
              text-align: center;
              height: 20px;
              justify-content: center;
              align-items: center;
              line-height: normal;
            }
          }
        }
      }
    }
  }
</style>
